// Offerable locales for the Create Language screen (I18nNewLanguagePage).
// Autocomplete suggestions only — the code field accepts any locale code.
// Canonical source: BaseApp platform i18n. Derived apps inherit this file; do not edit in a clone.
//
// Codes only: the screen names each one with localeName at render, so a
// suggestion is labelled by the same function that labels it everywhere else and
// in the admin's own UI language. Carrying a hardcoded English `name` here was
// how "English (US)" and "British English" ended up side by side.
export const LOCALE_CATALOG: string[] = [
  'EN_US',
  'EN_GB',
  'EN_CA',
  'EN_AU',
  // Scottish Standard English. Ten characters, because every locale column in
  // the schema is varchar(10) and its BCP-47 tag (en-GB-scotland) is fourteen —
  // see CSM_BCP47 in i18n/index.ts, which is what makes Intl name it properly.
  'EN_GB_SCOT',
  'ES_MX',
  'ES_ES',
  'FR_FR',
  'DE_DE',
  'PT_BR',
  'IT_IT',
  'NL_NL',
];
